import React, { useState } from 'react'
import { Box } from '@mui/joy'
import ContactUsLink from './ContactUsLink'
import LegalAgreement from './LegalAgreement'
import { useData } from './DataProvider'
import { SpinnerWhite } from '../../shared/Spinner'
import useTranslation from '../../shared/TranslationProvider'
import { apiPost } from '~/util/api'
import { Button } from '~/lib/ui/button'

export default function UnpauseCandidate() {
  const { legalNotice } = useData()
  const [loadingUnpause, setLoadingUnpause] = useState(false)
  const [loadingLogout, setLoadingLogout] = useState(false)

  const handleUnpause = async () => {
    setLoadingUnpause(true)
    try {
      const response = await apiPost('/unpause/handle_unpause')
      console.log('Unpause response:', response)
      if (response?.data?.success) {
        window.location.href = '/'
      }
    } catch (error) {
      console.error('Error unpausing candidate:', error)
    } finally {
      setLoadingUnpause(false)
    }
  }

  const handleLogout = async () => {
    setLoadingLogout(true)
    window.location.href = '/logout'
  }

  const { t } = useTranslation()

  return (
    <Box>
      <Box>
        <h1 className="m-8">{t('UnpauseCandidate.title')}</h1>
        <p className="my-8">{t('UnpauseCandidate.subtext1')}</p>
        <p className="my-8">{t('UnpauseCandidate.subtext2')}</p>
        <p className="my-8">{t('UnpauseCandidate.subtext3')}</p>
      </Box>
      <Box className="mb-3 flex flex-col space-y-7">
        <Button
          className="w-full"
          size="xl"
          onClick={handleUnpause}
          disabled={loadingUnpause || loadingLogout}
        >
          {t('UnpauseCandidate.continue')}
          <SpinnerWhite show={loadingUnpause} className="pl-4" />
        </Button>
        <Button
          variant="secondary"
          className="w-full"
          size="xl"
          onClick={handleLogout}
          disabled={loadingUnpause || loadingLogout}
        >
          {t('UnpauseCandidate.stay_in_pause')}
          <SpinnerWhite show={loadingLogout} className="pl-4" />
        </Button>
      </Box>
      <LegalAgreement
        actionText={t('UnpauseCandidate.continue')}
        htmlText={legalNotice}
      />
      <ContactUsLink />
    </Box>
  )
}
